import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadIconInternal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 26,
			cy: 26,
			r: 26,
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_5057_32910)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M35.8 23.3866C35.3521 21.1169 34.1301 19.0731 32.3428 17.6042C30.5554 16.1354 28.3135 15.3327 26 15.3333C22.1467 15.3333 18.8 17.5199 17.1333 20.7199C15.1736 20.9317 13.3613 21.8602 12.0447 23.327C10.728 24.7938 9.99977 26.6955 10 28.6666C10 30.7883 10.8429 32.8232 12.3431 34.3234C13.8434 35.8237 15.8783 36.6666 18 36.6666H35.3333C36.2088 36.6666 37.0757 36.4941 37.8846 36.1591C38.6934 35.8241 39.4283 35.333 40.0474 34.714C40.6664 34.0949 41.1575 33.36 41.4925 32.5511C41.8276 31.7423 42 30.8754 42 29.9999C42 26.4799 39.2667 23.6266 35.8 23.3866ZM35.3333 33.9999H18C16.5855 33.9999 15.229 33.438 14.2288 32.4378C13.2286 31.4376 12.6667 30.0811 12.6667 28.6666C12.6667 25.9333 14.7067 23.6533 17.4133 23.3733L18.84 23.2266L19.5067 21.9599C20.1198 20.7663 21.0505 19.765 22.1962 19.0663C23.3418 18.3676 24.6581 17.9986 26 17.9999C29.4933 17.9999 32.5067 20.4799 33.1867 23.9066L33.5867 25.9066L35.6267 26.0533C36.629 26.1207 37.5686 26.5652 38.2563 27.2975C38.944 28.0298 39.3289 28.9953 39.3333 29.9999C39.3333 31.0608 38.9119 32.0782 38.1618 32.8283C37.4116 33.5785 36.3942 33.9999 35.3333 33.9999ZM20.6667 27.3333H24.0667V31.3333H27.9333V27.3333H31.3333L26 21.9999L20.6667 27.3333Z",
				fill: "#079e88"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5057_32910",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				fill: "white",
				transform: "translate(10 10)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgUploadIconInternal);
export { ForwardRef as ReactComponent };
